import { render } from "./assistant_view.html?vue&type=template&id=04cde0e4&external"
import script from "./assistant_view.js?vue&type=script&lang=js&external"
export * from "./assistant_view.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__